import { deleteGenericDocuments } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
export const useDeleteGenericDocuments = () => {
    const { t } = useTranslation();
    const { fetchApi } = useFetchApi();
    const handleFetch = async (documentIds) => {
        const ret = await fetchApi(deleteGenericDocuments, { vars: { documentIds } }, {
            errorText: t('document.errors.deleteDocument'),
        });
        return ret;
    };
    return handleFetch;
};
